import { helper as buildHelper } from '@ember/component/helper';
import Striptags from 'striptags';

export function striptags(params/*, hash*/) {

  let text = params[0];

  if(typeof text !== 'string'){
    throw('Input must be a string!');
  } else {
    return Striptags(text);
  }

  return params;
}

export default buildHelper(striptags);
